import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setToken, setUser } from '../slices/authSlice';
import { useNavigate } from 'react-router-dom';
import { apiUrl } from '../config/api';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(apiUrl('/api/auth/login'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();
      console.log('Login response:', data);

      if (response.ok) {
        // 🔑 Token speichern
        dispatch(setToken(data.token));

        // 👤 User-Objekt extrahieren (egal ob verschachtelt oder flach)
        const user = data.user
          ? data.user // Backend gibt { user: {...}, token: ... }
          : {        // Backend gibt { _id, username, email, role, token }
              _id: data._id || data.id,
              username: data.username,
              email: data.email,
              role: data.role,
            };

        dispatch(setUser(user));

        navigate('/');
      } else {
        alert(data.message || 'Login fehlgeschlagen');
      }
    } catch (err) {
      alert('Netzwerkfehler beim Login');
    }

    setIsLoading(false);
  };

  return (
    <div className="container d-flex flex-column align-items-center justify-content-center min-vh-100">
      <h2 className="mb-4 text-center">Anmelden</h2>

      <form onSubmit={handleLogin} className="card p-4 shadow-sm w-100" style={{ maxWidth: 400 }}>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Benutzername"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <input
            type="password"
            className="form-control"
            placeholder="Passwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="d-grid">
          <button type="submit" className="btn btn-primary" disabled={isLoading}>
            {isLoading ? 'Bitte warten...' : 'Einloggen'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;
